export default {
    computed: {
        serviceDisplayTitle() {
            return this.serviceType == 'Dental' ? 'Check up and clean' : 'Eye test';
        },
        practitionerType() {
            return this.serviceType == 'Dental' ? 'Dentist' : 'Optometrist';
        }
    }
};
